import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from '@mui/material';
import { ROUTES } from '../constants/routes';
import { UserButton } from '@clerk/clerk-react';
import { useGreetingUser } from '../../common/hooks/useWelcomingText';

const AppBar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const path = location.pathname;
  const { greeting, date } = useGreetingUser();
  return (
    <>
      <div className='application-bar'>
        <Container maxWidth='lg' className='d-flex justify-content-between align-items-center'>
          {path === ROUTES.HOME && (
            <div className='name-date-container'>
              <div className='name-container'>{greeting}</div>
              <div className='date-container'>{date}</div>
            </div>
          )}
          <div className='flex-grow-1'></div>
          <div className='actions-container d-flex align-items-center position-relative'>
            {path === ROUTES.HOME && (
              <Link
                className='app-bar-link'
                to={ROUTES.DOCUMENT_LIBRARY + '?businessKitzLibrary=true'}
              >
                {t('buttons.browseBusinessKitzLibrary')}
              </Link>
            )}
            {/* <div className='notifications'>
            <NotificationsUnreadIcon />
          </div> */}
            <div className='avatar-item'>
              <UserButton />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};
export default AppBar;
